import React, { useState } from 'react'
import InputFill from '../form/InputFill'
import HeadingForm from '../elements/HeadingForm'
import Button from '../elements/Button'

import { useTranslation } from 'react-i18next'

const SearchOrderDetails = ({ handleSearch }) => {
    const [code, setCode] = useState('')
    const { t } = useTranslation()

    const handleSubmit = e => {
        e && e.preventDefault()

        code && handleSearch(code)
    }

    return (
        <form className="container py-4 flex-1" onSubmit={handleSubmit}>
            <HeadingForm>Kiểm tra đơn hàng</HeadingForm>

            <div className="row mt-8">
                <div className="col-12 col-md-6 offset-md-3">
                    <InputFill
                        value={code}
                        onChange={({ target: { value } }) => setCode(value)}
                    />
                </div>
            </div>

            <div className="mt-8 text-center">
                <Button>Tìm kiếm</Button>
            </div>
        </form>
    )
}

export default SearchOrderDetails
